import Vue from 'vue'
import Component from 'vue-class-component'
import AddButton from '../buttons/AddButton.vue'
import convoStore from '@/store/convo/convo-store'

@Component({
  name: 'statementConvoAdd',
  props: ['convo', 'statement'],
  components: { 'add-button' : AddButton },
})
export default class StatementCommentAdd extends Vue {

  protected addCommentStatement(): void {
    convoStore.dispatchAddCommentStatement(this.$props['statement'])
  }

}
